import { isEmptyArray } from "formik";
import { LOGIN_RESPONSE, SESSION_ID } from "../constants/LocalStorageKeyValuePairString";
import { getFromLocalStorage, getFromLocalStorageJsonObject } from "./localStorageUtils";
import DebugLog from "./DebugLog";

export const getButtonVisibilityData= (moduleName,subModuleName) => {
    const sessionId = getFromLocalStorage(SESSION_ID);
    let actionButtonList = []
    try {
      if (sessionId !== "") {
        const userDetails = getFromLocalStorageJsonObject(LOGIN_RESPONSE);

        let adjustments = [];

        if (!isEmptyArray(userDetails)) {
          let menuListSize = userDetails.length;
          if (menuListSize != null && menuListSize > 0) {
            userDetails.forEach((item, index) => {
              if (item.menuListName === moduleName) {
                adjustments = [...item.menuItem];
              }
            });

            adjustments.forEach((itemA, index) => {
              if (itemA.menuName === subModuleName) {
                 actionButtonList = [...itemA.actionButton];
                DebugLog(
                  "actionButtonList from sidebar    " +
                    JSON.stringify(actionButtonList)
                );

                // for (let i = 0; i < actionButtonList.length; i++) {
                //   if (actionButtonList[i].buttonName === "DOWNLOAD") {
                //     setDownlaodButton(true)
                // } else if(actionButtonList[i].buttonName === "ADD ADJUSTMENT"){
                //   setAddAdjustmentButton(true)
                // }
                // }

               
              

                // actionButtonList.forEach((items, index) => {
                //   if (items.buttonName === "DOWNLOAD") {
                //     setDownlaodButton(true);
                //   } else if (items.buttonName === "REQUEST RELEASE") {
                //     setRequestReleaseButton(true);
                //   } else if (items.buttonName === "RELEASE") {
                //     setReleaseButton(true);
                //   } else if (items.buttonName === "CANCEL") {
                //     setCancelButton(true);
                //   } else if (items.buttonName === "COMMENT") {
                //     setComment(true);
                //   }
                // });
              }
            });
          }
        }
      }

      return actionButtonList;
    } catch (error) {
      DebugLog(error);
    }
  };